/* Native Shrine content: stable anchors and progressive disclosure only. */
(()=>{
 const number=(key,fallback)=>Math.max(1,parseInt(getComputedStyle(document.documentElement).getPropertyValue(key),10)||fallback);
 function anchors(){
  const buy=document.getElementById('nsp-novasoin-ruban-achat');
  const form=document.querySelector('[id$="__produit"] product-form');
  if(buy&&form){form.before(buy);document.querySelectorAll('a[href^="/#nsp-novasoin-"]').forEach(a=>a.setAttribute('href',a.hash));}
  const faq=document.querySelector('.shopify-section[id$="__faq"]');
  if(faq&&!document.getElementById('nsp-novasoin-ruban-faq')){const mark=document.createElement('div');mark.id='nsp-novasoin-ruban-faq';mark.className='novasoin-anchor';faq.prepend(mark);}
 }
 function reviews(){
  const section=document.querySelector('.shopify-section[id$="__avis"]');
  const buttonSection=document.querySelector('.shopify-section[id$="__suiteavis"]');
  const button=buttonSection?.querySelector('a');
  if(!section||!button)return;
  const cards=[...section.querySelectorAll('.splide__list>.splide__slide')];
  if(!cards.length)return;
  let visible=number('--ns-reviews-initial',5);
  const apply=()=>{cards.forEach((card,i)=>card.hidden=i>=visible);buttonSection.hidden=visible>=cards.length;button.setAttribute('aria-expanded',String(visible>=cards.length));};
  button.onclick=event=>{event.preventDefault();visible=Math.min(cards.length,visible+number('--ns-reviews-step',1));apply();};
  section.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.splide__slide');const index=cards.indexOf(card);if(index>=visible){visible=index+1;apply();}});
  apply();
 }
 function init(){anchors();reviews();}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();